import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { Input, Row, Col, Spin, Empty, Button, Checkbox } from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';
import { Scrollbars } from 'react-custom-scrollbars';
import Modal from '../../../components/Modal/index';
import { USER } from 'api';
import request from '../../../utils/request';
import { ReactComponent as Key } from '../../../images/key_green.svg';
import { ReactComponent as WarnRedIcon } from '../../../images/warn_red.svg';
import { ReactComponent as WarnYellowIcon } from '../../../images/warn_yellow.svg';
import { ReactComponent as OpenGrayLock } from '../../../images/open_gray_lock.svg';
import { ReactComponent as NotAvalibleLock } from '../../../images/lock_gray_close.svg';
import { ReactComponent as BoxClose } from '../../../images/box-close.svg';
import { ReactComponent as OpenGreenLock } from '../../../images/opengreenlock.svg';
import { ReactComponent as OpenLockBlue } from '../../../images/lock_blue_open.svg';
import { ReactComponent as Undef } from '../../../images/lock-undf-open.svg';
import { ReactComponent as AvalibleLock } from '../../../images/lock_green_close.svg';

const Inner = styled.div`
  &&& {
    padding: 33px 40px 20px 40px;
    .ant-input-group {
      display: flex;
      flex-direction: column;
      .ant-input {
        border-radius: 6px;
        border-color: #e2e2e3;
      }
    }

    .ant-input-group-addon {
      background: none;
      border: none;
      padding: 0;
      color: #9f9f9f;
      margin-bottom: 8px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }
  }
`;

function ModalInfo({
  visible,
  setVisible,
  user,
  updateData,
  getBoxes,
  boxes,
  loadingBox,
  setBox,
  setVisibleBox,
  visibleBox,
  setVisibleAdd,
  visibleAdd,
  getUsers,
  setUser,
  source,
  setBoxNotLock
}) {
  const [usersBox, setUsersBox] = useState([]);
  const [count, setCount] = useState(3);
  const [logs, setLogs] = useState([]);
  const [tab, setTab] = useState('operation');
  const [loadingLogs, setLoadingLogs] = useState(false);

  const getLogs = async () => {
    setLoadingLogs(true);
    const response = await request(`${USER}/${user.id}/box_logs`);
    setLogs(response.objects);
    setLoadingLogs(false);
  };

  const { t } = useTranslation();
  const changePhone = (e) => {
    const phone = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
    if (user.phone !== phone) {
      updateData(
        {
          phone,
          id: user.id,
        },
        {
          sync: false,
          getSyncData: {
            fetchFunc: getUsers,
            params: {
              role: 'client',
            },
          },
        },
      );
    }
  };

  const changeEmail = (e) => {
    if (user.email !== e.target.value) {
      updateData(
        {
          email: e.target.value,
          id: user.id,
        },
        {
          sync: false,
          getSyncData: {
            fetchFunc: getUsers,
            params: {
              role: 'client',
            },
          },
        },
      );
    }
  };

  const openBox = (box) => {
    if(source === 'warehouse') {
      if (box.device) {
        setVisible(!visible);
        setVisibleBox(true);
        setBox(box);
      } else {
        setVisible(!visible);
        setVisibleAdd(!visibleAdd);
        setBoxNotLock(box);
      }
    }
    else {
      if (box.device) {
        setVisible(!visible);
        setVisibleBox(true);
        setBox(box);
      } else {
        setVisible(!visible);
        setVisibleAdd(!visibleAdd);
        setBox(box);
      }
    }

  };

  useEffect(() => {
    getBoxes({
      transaction__client_id: user.id,
    });
    getLogs();
  }, [user]);

  useMemo(() => {
    if (boxes) {
      setUsersBox(boxes);
    }
  }, [boxes]);

  const authUser = (id) => {
    updateData(
      {
        authorized:true,
        id,
      },
      {
        sync: false,
        getSyncData: {
          fetchFunc: getUsers,
          params: {
            role: 'client',
          },
        },
      },
    );
  }

  const afterClose = () => {
    setUser(null)
  }

  const unlinkParent = () => {
    updateData({
      parent_id:null,
      id:user.id
    })
  }

  return (
    <>
      <Modal afterClose={afterClose} visible={visible} width={727} setVisible={setVisible}>
        <Inner>
          <div className="flex items-center justify-between">
            <div className="text-22 font-bold text-black">
              {user.first_name} {user.last_name}
              <div>{user.parent_id !== null &&  <Button onClick={unlinkParent}>Unlink parent</Button> }</div>
            </div>
            <div className="border-b-1 border-dotted text-primary border-linkLine">
              {t('tikets')}(0/7)
            </div>
          </div>
          <div className="mt-20 flex items-center justify-between">
            <Row gutter={[16, 16]}>
              <Col span={10}>
                <div className="mb-8 text-graytext">{t('numPhone')}</div>
                <MaskedInput
                  value={user.phone}
                  onBlur={(e) => {
                    changePhone(e);
                  }}
                  className="w-full pl-9 pb-4 pt-4 border-1 border-lightGray rounded-xs focus:outline-none"
                  mask={[
                    '+',
                    ' ',
                    /[1-9]/,
                    '-',
                    /\d/,
                    /\d/,
                    /\d/,

                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    '-',
                    /\d/,
                    /\d/,
                    '-',
                    /\d/,
                    /\d/,
                  ]}
                />
              </Col>
              <Col span={14}>
                <Input
                  onBlur={(e) => {
                    changeEmail(e);
                  }}
                  type="email"
                  defaultValue={user.email}
                  addonBefore={t('email')}
                />
              </Col>
            </Row>
            {!user.authorized ? (
              <div onClick={() => {authUser(user.id)}} className="cursor-pointer flex items-center">
                {' '}
                <Key className="mr-15" />{' '}
                <div className="text-green">{t('authOne')}</div>{' '}
              </div>
            ) : null}
          </div>
          <Spin spinning={loadingBox}>
            <Scrollbars
              autoHeight
              autoHeightMin={77}
              autoHeightMax={300}
              renderTrackHorizontal={(props) => (
                <div
                  {...props}
                  className="track-horizontal"
                  style={{ display: 'none' }}
                />
              )}
              renderThumbHorizontal={(props) => (
                <div
                  {...props}
                  className="thumb-horizontal"
                  style={{ display: 'none' }}
                />
              )}
            >
              {usersBox ? (
                usersBox.length !== 0 ? (
                  usersBox.slice(0, count).map((item) => {
                    return (
                      <div className="flex mb-10 items-center justify-between h-77 rounded-lg border-1 border-lightGray pr-19 pl-24">
                        <div className="flex flex-col">
                          <div className="text-16 font-bold text-black">
                            {t('storage')} {`"${item.section.warehouse.name}"`}
                          </div>
                          <div className="flex items-center">
                            <div className="mr-10 text-16 text-black">
                              {item.name}
                            </div>
                            <div>
                              {item.transaction ? (
                                item.transaction.expired ? (
                                  <div className="flex text-red items-center">
                                    <WarnRedIcon className="mr-6 w-14" />
                                    {t('delay')}{' '}
                                    {moment().diff(
                                      moment(item.transaction.paid_till),
                                      'days',
                                    )}{' '}
                                    {t('days')}
                                  </div>
                                ) : Number(
                                    moment().diff(
                                      moment(item.transaction.paid_till),
                                      'days',
                                    ),
                                  ) <= 7 &&
                                  Number(
                                    moment().diff(
                                      moment(item.transaction.paid_till),
                                      'days',
                                    ),
                                  ) > 0 ? (
                                  <div className="flex text-yellow items-center">
                                    <WarnYellowIcon className="mr-6 w-14" />
                                    {t('paymentWillEndInAWeek')}
                                  </div>
                                ) : (
                                  <div className="flex items-center text-green">
                                    {t('paidBefore')}{' '}
                                    {moment(item.transaction.paid_till).format(
                                      'DD MMMM YYYY',
                                    )}
                                  </div>
                                )
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center">
                          {item.available ? (
                            //открыт арендатором
                            item.device &&
                            item.device.telemetry.open &&
                            (item.device.open_close_type === 'button' ||
                              (item.device.open_close_type === 'backend' &&
                                item.device.open_close_user.role ===
                                  'client') ||
                              (item.device.open_close_type === 'bluetooth' &&
                                item.device.open_close_user.role ===
                                  'client')) ? (
                              <>
                                <span
                                  className={
                                    item.expired
                                      ? 'rounded-full border-red border-2 h-35 w-35 pl-8 pt-6 mr-50'
                                      : null
                                  }
                                >
                                  <OpenLockBlue
                                    className={item.expired ? null : 'mr-60'}
                                  />
                                </span>
                              </>
                            ) : //открыт админом
                            item.device &&
                              item.device.telemetry.open &&
                              item.device.open_close_type === 'backend' &&
                              item.device.open_close_user.role === 'admin' ? (
                              <>
                                <span
                                  className={
                                    item.expired
                                      ? 'rounded-full border-red border-2 h-35 w-35 pl-8 pt-6 mr-50'
                                      : null
                                  }
                                >
                                  <OpenGreenLock
                                    className={item.expired ? null : 'mr-60'}
                                  />{' '}
                                </span>
                              </>
                            ) : item.device &&
                              item.device.telemetry.open &&
                              !item.device.open_close_type ? (
                              <>
                                {' '}
                                <Undef className="mr-60" />{' '}
                              </>
                            ) : (
                              <>
                                <span
                                  className={
                                    item.expired
                                      ? 'rounded-full border-red border-2 h-35 w-35 pl-8 pt-6 mr-50'
                                      : null
                                  }
                                >
                                  {' '}
                                  <AvalibleLock className="mr-60" />{' '}
                                </span>
                              </>
                            )
                          ) : (
                            <>
                              <span
                                className={
                                  item.expired
                                    ? 'rounded-full border-red border-2 h-35 w-35 pl-8 pt-6 mr-50'
                                    : 'flex'
                                }
                              >
                                <NotAvalibleLock className="mr-60" />{' '}
                              </span>
                            </>
                          )}
                          <div
                            onClick={() => {
                              openBox(item);
                            }}
                            className="text-primary cursor-pointer border-b-1 border-dotted"
                          >
                            {t('watchBoxing')}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <Empty />
                )
              ) : null}
              {usersBox.length > 3 && count !== usersBox.length ? (
                <div className="flex items-center justify-center">
                  <Button
                    type="link"
                    onClick={() => {
                      setCount(usersBox.length);
                    }}
                    className="text-black hover:text-black hover:border-black h-auto p-0 m-0 border-t-0 border-r-0 border-l-0 rounded-none border-b-1 border-dotted border-black"
                  >
                    {t('showMore')} ({usersBox.length - 3})
                  </Button>
                </div>
              ) : null}
            </Scrollbars>
          </Spin>
        </Inner>
        <Row type="flex" align="middle">
          <Col span={5}>
            <div className="w-full h-1 bg-darkGray"></div>
          </Col>
          <Col span={6}>
            <div
              onClick={() => {
                setTab('operation');
              }}
              className=" text-18 text-black font-semibold flex cursor-pointer justify-center items-center"
            >
              <span
                className={
                  tab === 'session'
                    ? 'cursor-pointer text-primary border-b-1 border-dotted border-linkLine'
                    : 'cursor-pointer'
                }
              >
                {/* {t('historyOperation')}afdsafd */}

                test sss
              </span>
            </div>
          </Col>
          <Col className="pl-10" span={2}>
            <div className="w-full  h-1 bg-darkGray"></div>
          </Col>
          <Col span={6}>
            <div
              onClick={() => {
                setTab('session');
              }}
              className="flex text-18 text-black font-semibold justify-center items-center"
            >
              <span
                className={
                  tab === 'operation'
                    ? 'cursor-pointer text-primary border-b-1 border-dotted border-linkLine'
                    : 'cursor-pointer'
                }
              >
                {t('historySession')}
              </span>
            </div>
          </Col>
          <Col span={5}>
            <div className="w-full h-1 bg-darkGray"></div>
          </Col>
        </Row>
        <Inner>
          <Scrollbars
            autoHeight
            autoHeightMin={77}
            autoHeightMax={150}
            renderTrackHorizontal={(props) => (
              <div
                {...props}
                className="track-horizontal"
                style={{ display: 'none' }}
              />
            )}
            renderThumbHorizontal={(props) => (
              <div
                {...props}
                className="thumb-horizontal"
                style={{ display: 'none' }}
              />
            )}
          >
            <Spin spinning={loadingLogs}>
              {tab === 'session' ? (
                <Row className="border-b-1 border-solid border-lightGray pt-20 pb-20">
                  <Col span={8}>
                    <div className="flex">
                      <div className="border-r-1 pr-5 border-gray">20 мая</div>
                      <div className="ml-5 text-graytext">14:23</div>
                    </div>
                  </Col>
                  <Col span={6}>{t('applicationInTouch')}</Col>
                </Row>
              ) : logs ? (
                logs.length !== 0 ? (
                  map(logs, (log) => {
                    return (
                      <div className="operation">
                        <Row
                          justify="space-between"
                          className="border-b-1 border-solid border-lightGray pt-20 pb-20"
                        >
                          <Col span={6}>
                            <div className="flex">
                              <div className="border-r-1 pr-5 border-gray">
                                {moment(log.datetime).format('DD MMMM')}
                              </div>
                              <div className="ml-5 text-graytext">
                                {' '}
                                {moment(log.datetime)
                                  .subtract(
                                    new Date(log.datetime).getTimezoneOffset(),
                                    'minutes',
                                  )
                                  .format('HH:mm')}
                              </div>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div className="flex items-center">
                              {log.type === 'open' ? (
                                <>
                                  <OpenGrayLock className="pr-7 w-23" />{' '}
                                  {t('boxOpen')}
                                </>
                              ) : (
                                <>
                                  <BoxClose className="mr-10" /> {t('boxClose')}
                                </>
                              )}
                            </div>
                          </Col>
                          <Col span={5}>{log.box.section.warehouse.name}</Col>
                          <Col span={7}>
                            <div className="flex justify-end">
                              {log.box.name}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    );
                  })
                ) : (
                  <Empty />
                )
              ) : null}
            </Spin>
          </Scrollbars>
        </Inner>
      </Modal>
    </>
  );
}

ModalInfo.propTypes = {};

export default ModalInfo;
